/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { MenuItem } from 'primeng/api/menuitem';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { LocoTransfer } from '../../../core/model/loco-transfer.model';
import { TabData } from '../../../core/model/tab-data.model';
import { TerminalStatus } from '../../../core/model/terminal-status.model';
import { TrainData } from '../../../core/model/train-data.model';
import { ConfigService } from '../../../core/services/config.service';
import { DataStoreService } from '../../../core/services/datastore.service';
import { PopupService } from '../../../core/services/popup.service';
import { UserService } from '../../../core/services/user.service';
import { TerminalConfigService } from '../../shared/services/terminal-config.service';
import { BaseResponse } from './../../../core/model/base-response.model';
import { BreTransferAreaDetails } from './../../../core/model/bre-transfer-area-details.model';
import { LmsException } from './../../../core/model/lms-exception.model';
import { Tab } from './../../../core/model/tab.model';
import { TerminalCommonInfo } from './../../../core/model/terminal-common-info.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { EditModeService } from './../../../core/services/edit-mode.service';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { LmsModuleService } from './../../../core/services/lms-module.service';
import { LmsTabsDragDropService } from './../../../core/services/lms-tabs-drag-drop.service';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { UtilService } from './../../../core/services/util.service';
import { AddToPendingList } from './../../shared/model/terminal-pending.model';
import { AddToPendingService } from './../../shared/services/add-to-pending.service';
import { TerminalStatusService } from './../../shared/services/terminal-status.service';
import { CheckboxModule } from 'primeng/checkbox';





/**
 * @export
 * @class LmsTerminalHeaderComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-status-header',
  templateUrl: './lms-terminal-status-header.component.html',
  styleUrls: ['./lms-terminal-status-header.component.scss']
})
export class LmsTerminalStatusHeaderComponent implements AfterViewInit, OnDestroy, OnChanges, OnInit {

  @Input() subTypes: Array<string>;
  @Input() tab: Tab;
  summary: TerminalCommonInfo;
  @Input() allStatusdata;
  @Input() spinnerVal;
  @Output() lmsExceptionOutput = new EventEmitter();
  responseHeader: BaseResponse;
  spinnerConfigData: any;
  tabLevel: number;
  terminalNAIcon: string;
  trainSelected: Boolean;
  locosSelected: Boolean;
  trainLocosData: Object;
  enablePendingList: Boolean;
  @Input() noThroughTrains: Boolean;
  private lmsTabsDragDropSubscribe;
  private addToPendingSubscribe;
  private enablePendingListSubscribe;
  showPendingList: Boolean = false;
  pendingActions: Array<AddToPendingList> = [];
  pendingActionsLength: number = 0;
  private submitPendingActionLength = 0;
  configData: any;
  thpPlanLoco = 'S';
  private pendingActionCounter = 0;
  private totalCheckedPendingCounter = 0;
  private errorPendingCounter = 0;
  transferResponse;
  ruleExceptionInfoPopup = false;
  lmsExceptionList: Array<LmsException> = [];
  locoTransfer: Array<LocoTransfer> = [];
  showWarnPop = false;
  warnMessage = 'Unsaved data will be lost. Do you want to continue?';
  saveSpinNoThroughTrainData: Object;
  lastSpinValue;
  terminalConfigMessage;
  trainClickCounter = 0;
  locoClickCounter = 0;
  totalCancellableLocos = 0;
  locoPlanTrain: TrainData;
  otherOptions: MenuItem[];
  allocateRole: string;
  commonopsPicklist: any;
  showHeader: boolean;

  constructor(
    private configService: ConfigService,
    private lmsTabsDragDropService: LmsTabsDragDropService,
    private addToPendingService: AddToPendingService,
    private editModeService: EditModeService,
    private staticDataStoreService: StaticDataStoreService,
    private messageHandlerService: MessageHandlerService,
    private terminalStatusService: TerminalStatusService,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService,
    private utilService: UtilService,
    private lmsModuleService: LmsModuleService,
    private terminalConfigService: TerminalConfigService,
    private popUpService: PopupService,
    private dataStoreService: DataStoreService, 
    public user: UserService) {

    if (staticDataStoreService.getValue('SHOW_HEADER') == false)
      this.showHeader = false;
    else
      this.showHeader = true;

    this.configData = this.configService.getConfigData();
    this.terminalConfigMessage = this.terminalConfigService.terminalConfigData.messages;
    this.spinnerConfigData = this.terminalConfigService.terminalConfigData.header.spinner;
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
    this.terminalNAIcon = this.configService.getConfigData().images.topAction.terminal.terminalNAIcon;
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.commonopsPicklist &&
      this.commonopsPicklist.masterData &&
      this.commonopsPicklist.masterData.userAuthDetails &&
      this.commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = this.commonopsPicklist.masterData.userAuthDetails.allocationRole;
    }
    this.lmsTabsDragDropSubscribe = this.lmsTabsDragDropService.interactiveLocoTrains$.subscribe(data => {
      this.trainSelected = false;
      this.locosSelected = false;
      this.enableDisableTrainOrLocoOperationButtons();
      if (this.trainSelected || this.locosSelected) {
        this.resetLoco();
      }
    });

    this.enablePendingListSubscribe = this.addToPendingService.enablePendingList$.subscribe(data => {
      this.enablePendingList = (data && (this.pendingActionsLength !== 0));
    });


    this.addToPendingSubscribe = this.addToPendingService.terminalPL$.subscribe(data => {
      this.pendingActions = data['pendingList'];
      this.pendingActionsLength = this.pendingActions ? this.pendingActions.length : 0;
      let editModeStatus = {};
      if (this.pendingActionsLength) {

        const actionname = this.pendingActionsLength > 1 ? 'actions' : 'action';
        editModeStatus = {
          status: true,
          message: `${this.terminalConfigMessage.youHave} ${this.pendingActionsLength} ${actionname} ${this.terminalConfigMessage.pendingWithoutSubmit}`
        };
      } else {
        editModeStatus = {
          status: false,
          message: ''
        };
      }
      this.editModeService.setEditMode(editModeStatus);
    });
  }

  ngOnInit(): void {
    this.locosSelected = false;
    this.otherOptions = [];
    this.prepareOtherOptionsMenu();
  }

  /**
   * Submit pending actions.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  submitPendingAction() {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    this.totalCheckedPendingCounter = 0;
    this.pendingActionCounter = 0;
    this.errorPendingCounter = 0;
    const pendingActionsLength = this.pendingActions.length;
    this.submitPendingActionLength = pendingActionsLength;
    const checkTrainTypeOperation = _.filter(this.pendingActions, (item) => {
      return item.action === 'complete' || item.action === 'cancel';
    }).length;
    // let requestCounter = 0;
    if (checkTrainTypeOperation) {
      // all operation are train related Exist
      for (let i = 0; i < pendingActionsLength; i++) {
        const checkedTrains = _.filter(this.pendingActions[i].trains, { checked: true });
        if (checkedTrains.length) {
          this.totalCheckedPendingCounter++;
          this.cancelCompleteTrainOperation(checkedTrains, `${this.pendingActions[i].action}Train`, i);
        } else {
          this.pendingActionCounter++;
          this.loadFreshData();
        }
      }
    } else {
      // all operation are loco related Exist
      for (let i = 0; i < pendingActionsLength; i++) {
        const checkedLocos = _.filter(this.pendingActions[i].locos, { checked: true });
        if (checkedLocos.length) {
          this.totalCheckedPendingCounter++;
          this.planLocomotiveSubmit(this.pendingActions[i], i);
        } else {
          this.pendingActionCounter++;
          this.loadFreshData();
        }
      }

    }
  }

  /**
   * Load fresh data when some operation perfromed.
   * @private
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  private loadFreshData() {
    if (this.pendingActionCounter === this.submitPendingActionLength) {
      if (this.totalCheckedPendingCounter >= this.errorPendingCounter) {
        for (let k = (<number>this.pendingActionsLength - 1); k >= 0; k--) {
          if (this.pendingActions[k].delete) {
            this.pendingActions.splice(k, 1);
          }
        }
        this.pendingActionsLength = this.pendingActions.length;
        this.trainSelected = false;
        this.locosSelected = false;
        const countOfSuccessOperation = this.totalCheckedPendingCounter - this.errorPendingCounter;
        if (countOfSuccessOperation > 0) {
          const messagePart = ((countOfSuccessOperation) === 1) ? 'operation is' : 'operations are';
          this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
          this.editModeService.setEditMode({ status: false, message: '' });
          if (!this.pendingActions.length) {
            this.addToPendingService.resetAll();
          }
          this.terminalStatusService.updatePendingStatus = this.pendingActions;
          const message = `Pending actions successful. ${this.totalCheckedPendingCounter}/${countOfSuccessOperation} (${this.totalCheckedPendingCounter} action(s) submitted / ${countOfSuccessOperation} action(s) successful)`;
          this.terminalStatusService.load(this.tab,
            true, message);
        } else {
          this.addToPendingService.updatePendingListData({ pendingList: this.pendingActions });
        }
      } else {
        this.addToPendingService.updatePendingListData({ pendingList: this.pendingActions });
      }
    }
  }

  /**
   * Invoked for cancal or complete train operations.
   * @param {any} trains
   * @param {string} event
   * @param {any} pendingActionindex
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  public cancelCompleteTrainOperation(trains, event: string, pendingActionindex) {
    this.lmsLoaderService.showLoader();
    let opr: any;
    const cancelTrain = {
      station: this.tab.tabSearchParameter.searchText,
      trainRow: [

      ]
    };

    for (let k = 0; k < trains.length; k++) {
      cancelTrain.trainRow.push({
        trainID: trains[k].trainIdentifier,
        trainType: trains[k].trainType
      });
    }
    if (event && event === 'completeTrain') {
      opr = 'CMPL';
    } else if (event && event === 'cancelTrain') {
      opr = 'CNCL';
    }
    let responseHeader = null;
    this.terminalStatusService.cancelCompleteTrain(cancelTrain, opr).subscribe(
      (data) => {
        responseHeader = data;
        if (this.appUtilityService.isNumeric(responseHeader.header.priorityCode)) {
          const pCode = parseInt(responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            const chekedTrains = this.pendingActions[pendingActionindex].trains;
            for (let k = chekedTrains.length - 1; k >= 0; k--) {
              if (chekedTrains[k].checked) {
                this.pendingActions[pendingActionindex].trains.splice(k, 1);
              }
            }
            if (!this.pendingActions[pendingActionindex].trains.length) {
              this.pendingActions[pendingActionindex].delete = true;
            }
            this.lmsLoaderService.hideLoader();
            this.pendingActionCounter++;
            this.loadFreshData();
          } else {
            this.lmsLoaderService.hideLoader();
            this.setErrorInPendingAction(this.pendingActions[pendingActionindex], responseHeader.header.messageText, 'trains');
            this.loadFreshData();
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.setErrorInPendingAction(this.pendingActions[pendingActionindex], this.appUtilityService.getHttpErroMessage(error, false), 'trains');
        this.loadFreshData();
      }
    );
  }

  /**
   * Setting the error in pending action when pending action failed to submit.
   * @private
   * @param {AddToPendingList} pendingAction
   * @param {string} errorMessage
   * @param {string} pendingActionType
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  private setErrorInPendingAction(pendingAction: AddToPendingList, errorMessage: string, pendingActionType: string) {
    for (let k = 0; k < pendingAction[pendingActionType].length; k++) {
      pendingAction[pendingActionType][k].checked = false;
    }
    pendingAction.hasError = true;
    pendingAction.errorMessage = errorMessage;
    this.pendingActionCounter++;
    this.errorPendingCounter++;
  }

  /**
   * Invoked for submitting the plan locomotive
   * @param {AddToPendingList} pendingAction
   * @param {any} pendingActionIndex
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  planLocomotiveSubmit(pendingAction: AddToPendingList, pendingActionIndex) {
    const action = pendingAction.action;
    if (action === 'Foreign Railroad') {
      this.lmsLoaderService.showLoader();
      this.submitTransferToForeignRailRoad(pendingAction, pendingActionIndex);
    } else if (action === 'Train') {
      const trainId = pendingAction.trains[0].trainIdentifier;
      if (this.appUtilityService.isValidTrainId(trainId)) {
        const selectedLocmotives = _.filter(pendingAction.locos, { checked: true });
        const locoId: Array<String> = [];
        const breSubmitLocoTransfer: Array<LocoTransfer> = [];
        for (let i = 0; i < selectedLocmotives.length; i++) {
          const selectedLocmotive = selectedLocmotives[i];
          if (selectedLocmotive && selectedLocmotive.isSubmitBreLoco) {
            if (!selectedLocmotive.isLmsExceptionInAddReason && !selectedLocmotive.isLmsExceptionInAddQShop) {
              const lTransfer = {
                currentTerminalIdentifier: this.tab.tabSearchParameter.searchText, // To be To be verified
                terminalHandlingType: pendingAction.planLoco,
                trainIdentifier: trainId,
                locoTransferList: {
                  locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                  qualifier: selectedLocmotive.qualifier,
                  assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                  tripPlanCompIndicator: selectedLocmotive.tripPlamCompExcptnInd,
                  tripPlanTrainIdentifier: selectedLocmotive.tripPlanTrnId,
                  tripPlanOverrideCode: selectedLocmotive.tripPlanOverrideCode,
                  tripPlanOverrideReason: selectedLocmotive.tripPlanOverrideReason,
                  unscheduledQShop: selectedLocmotive.unscheduledQShop,
                  unscheduledQShopDate: selectedLocmotive.unscheduledQShopDate,
                  intendedUsageCode: selectedLocmotive.intendedUsageCode,
                  intendedUsageReason: selectedLocmotive.intendedUsageReason,
                  intendedUsageNotes: selectedLocmotive.intendedUsageNote
                }
              };
              breSubmitLocoTransfer.push(lTransfer);
            }
          } else {
            locoId.push(this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier));
          }
        }
        if (locoId && locoId.length > 0) {
          this.serviceCallToBre(pendingAction, trainId, locoId, 'planLocomotive', pendingActionIndex);
        }
        if (breSubmitLocoTransfer && breSubmitLocoTransfer.length > 0) {
          this.serviceCallLocoTransfer(breSubmitLocoTransfer, 'XTRN', pendingActionIndex);
        }
      }
    } else if (action === 'Terminal') {
      this.lmsLoaderService.showLoader();
      this.submitTransferToTerminal(pendingAction, pendingActionIndex);
    } else if (action === 'resequence') {
      this.lmsLoaderService.showLoader();
      this.resequenceLocmotiveSubmit(pendingAction, pendingActionIndex);
    } else if (action === 'CancelLocomotivePlan' || action === 'CancelTrainLocomotivePlan') {
      this.lmsLoaderService.showLoader();
      this.cancelLocoMotivePlan(pendingAction, pendingActionIndex);
    } else if (action === 'UpdateThp') {
      this.lmsLoaderService.showLoader();
      this.updateThp(pendingAction, pendingActionIndex);
    }
  }

  private cancelLocoMotivePlan(pendingAction: AddToPendingList, pendingActionIndex: number) {
    this.terminalStatusService.cancelLocomotivePlan(pendingAction.contextMenuOperation['data'], pendingAction.contextMenuOperation['currentTerminal'], pendingAction.contextMenuOperation['windowCode']).subscribe(
      (data) => {
        this.responseHeader = data;
        if (this.appUtilityService.isNumeric(this.responseHeader.header.priorityCode)) {
          const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.lmsLoaderService.hideLoader();
            this.pendingActions[pendingActionIndex].delete = true;
            this.lmsLoaderService.hideLoader();
            this.pendingActionCounter++;
            this.loadFreshData();
          } else {
            this.lmsLoaderService.hideLoader();
            if (this.pendingActions[pendingActionIndex].action === 'CancelTrainLocomotivePlan') {
              for (let k = 0; k < this.pendingActions[pendingActionIndex].trains.length; k++) {
                this.pendingActions[pendingActionIndex].trains[k].checked = false;
              }
            } else {
              for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
                this.pendingActions[pendingActionIndex].locos[k].checked = false;
              }
            }
            this.pendingActions[pendingActionIndex].hasError = true;
            this.pendingActions[pendingActionIndex].errorMessage = this.responseHeader.header.messageText;
            this.errorPendingCounter++;
            this.pendingActionCounter++;
            this.loadFreshData();
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        if (this.pendingActions[pendingActionIndex].action === 'CancelTrainLocomotivePlan') {
          for (let k = 0; k < this.pendingActions[pendingActionIndex].trains.length; k++) {
            this.pendingActions[pendingActionIndex].trains[k].checked = false;
          }
        } else {
          for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
            this.pendingActions[pendingActionIndex].locos[k].checked = false;
          }
        }
        this.pendingActions[pendingActionIndex].hasError = true;
        this.pendingActions[pendingActionIndex].errorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        this.errorPendingCounter++;
        this.pendingActionCounter++;
        this.loadFreshData();
      }
    );
  }

  private updateThp(pendingAction: AddToPendingList, pendingActionIndex: number) {
    this.terminalStatusService.updateThp(pendingAction.contextMenuOperation).subscribe(
      (data) => {
        this.responseHeader = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.responseHeader.header.priorityCode)) {
          const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.lmsLoaderService.hideLoader();
            this.pendingActions[pendingActionIndex].delete = true;
            this.lmsLoaderService.hideLoader();
            this.pendingActionCounter++;
            this.loadFreshData();
          } else {
            this.lmsLoaderService.hideLoader();
            for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
              this.pendingActions[pendingActionIndex].locos[k].checked = false;
            }
            this.pendingActions[pendingActionIndex].hasError = true;
            this.pendingActions[pendingActionIndex].errorMessage = this.responseHeader.header.messageText;
            this.errorPendingCounter++;
            this.pendingActionCounter++;
            this.loadFreshData();
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
          this.pendingActions[pendingActionIndex].locos[k].checked = false;
        }
        this.pendingActions[pendingActionIndex].hasError = true;
        this.pendingActions[pendingActionIndex].errorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        this.errorPendingCounter++;
        this.pendingActionCounter++;
        this.loadFreshData();
      }
    );
  }

  submitTransferToTerminal(pendingAction: AddToPendingList, pendingActionIndex: number) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForTerminal(locoTransfer, pendingAction);
    this.serviceCallLocoTransfer(locoTransfer, 'XSTA', pendingActionIndex);
  }

  submitTransferToForeignRailRoad(pendingAction: AddToPendingList, pendingActionIndex: number) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForForeignRoad(locoTransfer, pendingAction);
    this.serviceCallLocoTransfer(locoTransfer, 'XROD', pendingActionIndex);
  }


  createLocoTransferListForForeignRoad(locoTransfer: Array<LocoTransfer>, pendingAction: AddToPendingList) {
    const selectedLocmotives = _.filter(pendingAction.locos, { checked: true });
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = selectedLocmotives[i];
      const a = {
        currentTerminalIdentifier: this.tab.tabSearchParameter.searchText, // To be verified
        toRoadIdentifier: pendingAction.road,
        terminalHandlingType: ' ',
        atStation: pendingAction.terminal,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);

    }
  }
  private resequenceLocmotiveSubmit(pendingAction: AddToPendingList, pendingActionIndex: number) {
    const trainIdentifier = pendingAction.trains[0].trainIdentifier;
    const locosList = _.filter(this.allStatusdata.terminalStatusIO.outBoundTrains, { trainIdentifier: trainIdentifier }).length ?
      _.filter(this.allStatusdata.terminalStatusIO.outBoundTrains, { trainIdentifier: trainIdentifier })[0]['locoDetails'] :

      (_.filter(this.allStatusdata.terminalStatusIO.inBoundTrains, { trainIdentifier: trainIdentifier }).length ? _.filter(this.allStatusdata.terminalStatusIO.inBoundTrains, { trainIdentifier: trainIdentifier })[0]['locoDetails'] : []);
    const request = {
      thpTerminal: this.tab.tabSearchParameter.searchText,
      terminalHandlingType: '',
      trainId: trainIdentifier,
      otherLocosList: this.appUtilityService.getLocomotiveList(locosList)
    };
    let responseHeader = null;
    this.terminalStatusService.resequenceLocomotives(request, this.tab.tabSearchParameter.searchText).subscribe(
      (data) => {
        responseHeader = data;
        if (this.isNumeric(responseHeader.header.priorityCode)) {
          const pCode = parseInt(responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.pendingActions[pendingActionIndex].delete = true;
            this.lmsLoaderService.hideLoader();
            this.pendingActionCounter++;
            this.loadFreshData();
          } else {
            this.lmsLoaderService.hideLoader();
            for (let k = 0; k < this.pendingActions[pendingActionIndex].trains.length; k++) {
              this.pendingActions[pendingActionIndex].trains[k].checked = false;
            }
            this.pendingActions[pendingActionIndex].hasError = true;
            this.pendingActions[pendingActionIndex].errorMessage = responseHeader.header.messageText;
            this.errorPendingCounter++;
            this.pendingActionCounter++;
            this.loadFreshData();
          }

        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        for (let k = 0; k < this.pendingActions[pendingActionIndex].trains.length; k++) {
          this.pendingActions[pendingActionIndex].trains[k].checked = false;
        }
        this.pendingActions[pendingActionIndex].hasError = true;
        this.pendingActions[pendingActionIndex].errorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        this.errorPendingCounter++;
        this.pendingActionCounter++;
        this.loadFreshData();
      }
    );
  }
  createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, pendingAction: AddToPendingList) {
    const selectedLocmotives = _.filter(pendingAction.locos, { checked: true });
    for (let i = 0; i < selectedLocmotives.length; i++) {
      const selectedLocmotive = selectedLocmotives[i];
      const a = {
        currentTerminalIdentifier: this.tab.tabSearchParameter.searchText, // To be To be verified
        terminalIdentifier: pendingAction.terminal,
        terminalHandlingType: pendingAction.planLoco,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);
    }
  }

  serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string, pendingActionIndex: number) {
    this.terminalStatusService.transferLocomotive(locoTransfer, operation).subscribe(
      (data) => {
        this.transferResponse = data;
        if (this.appUtilityService.isNumeric(this.transferResponse.header.priorityCode)) {
          const pCode = parseInt(this.transferResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            const checkedLocos = this.pendingActions[pendingActionIndex].locos;
            for (let k = checkedLocos.length - 1; k >= 0; k--) {
              if (checkedLocos[k].checked) {
                this.lmsExceptionList = this.lmsExceptionList.filter((lmsException) => {
                  return this.appUtilityService.formatLocomotiveId(lmsException.locoId)
                    !== this.appUtilityService.formatLocomotiveId(checkedLocos[k].locomotiveIdentifier);
                });
                this.pendingActions[pendingActionIndex].locos.splice(k, 1);
              }
            }
            if (!this.pendingActions[pendingActionIndex].locos.length) {
              this.pendingActions[pendingActionIndex].delete = true;
            }
            this.lmsLoaderService.hideLoader();
            this.pendingActionCounter++;
            this.loadFreshData();
          } else {
            this.lmsLoaderService.hideLoader();
            for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
              this.pendingActions[pendingActionIndex].locos[k].checked = false;
            }
            this.pendingActions[pendingActionIndex].hasError = true;
            this.pendingActions[pendingActionIndex].errorMessage = this.transferResponse.header.messageText;
            this.errorPendingCounter++;
            this.pendingActionCounter++;
            this.loadFreshData();
          }
        }

      }, error => {
        this.lmsLoaderService.hideLoader();
        for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
          this.pendingActions[pendingActionIndex].locos[k].checked = false;
        }
        this.pendingActions[pendingActionIndex].hasError = true;
        this.pendingActions[pendingActionIndex].errorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        this.errorPendingCounter++;
        this.pendingActionCounter++;
        this.loadFreshData();
      });
  }

  private enableDisableTrainOrLocoOperationButtons() {
    const inBoundTrains = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const terminalList = this.allStatusdata.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    this.trainClickCounter = 0;
    this.locoClickCounter = 0;
    this.locoPlanTrain = null;
    this.totalCancellableLocos = 0;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (inBoundTrains[i].clicked && !inBoundTrains[i].inPendingList) {
        this.trainClickCounter++;
        this.locoPlanTrain = inBoundTrains[i];
        break;
      }
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (outBoundTrains[i].clicked && !outBoundTrains[i].inPendingList) {
        this.trainClickCounter++;
        this.locoPlanTrain = outBoundTrains[i];
        break;
      }
    }

    if (!this.trainSelected) {
      for (let i = 0; i < inBoundTrainsLength; i++) {
        for (let j = 0; j < inBoundTrains[i].locoDetails.length; j++) {
          if (inBoundTrains[i].locoDetails[j].clicked && !inBoundTrains[i].locoDetails[j].inPendingList) {
            this.locoClickCounter++;
            if (this.appUtilityService.isPlannedLoco(inBoundTrains[i].locoDetails[j])) {
              this.totalCancellableLocos++;
            }
            // break;
          }
        }
      }

      for (let i = 0; i < outBoundTrainsLength; i++) {
        for (let j = 0; j < outBoundTrains[i].locoDetails.length; j++) {
          if (outBoundTrains[i].locoDetails[j].clicked && !outBoundTrains[i].locoDetails[j].inPendingList) {
            this.locoClickCounter++;
            if (this.appUtilityService.isPlannedLoco(outBoundTrains[i].locoDetails[j])) {
              this.totalCancellableLocos++;
            }
            // break;
          }
        }
      }
      const locosLength = totalTerminalListLocos.length;
      for (let k = 0; k < locosLength; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          for (let l = 0; l < totalTerminalListLocos[k].length; l++) {
            if (totalTerminalListLocos[k][l].clicked && !totalTerminalListLocos[k][l].inPendingList) {
              this.locoClickCounter++;
              if (this.appUtilityService.isPlannedLoco(totalTerminalListLocos[k][l])) {
                this.totalCancellableLocos++;
              }
              // break;
            }
          }
        }
      }

      if (this.trainClickCounter === 1 && this.locoClickCounter) {
        this.locosSelected = true;
      } else if (this.trainClickCounter) {
        this.trainSelected = true;
      } else if (this.locoClickCounter) {
        this.locosSelected = true;
      }
    }
    this.prepareOtherOptionsMenu();
  }

  private resetLoco() {
    if (this.allStatusdata && this.allStatusdata.isLocated) {
      const locoArray = this.allStatusdata.terminalStatusLocos[this.allStatusdata.isLocatedKey];
      const tabData = this.dataStoreService.getValue(this.tab);
      const terminalStatus = <TerminalStatus>(tabData.data[this.tab.subType]);
      for (let i = 0; i < locoArray.length; i++) {
        if (locoArray[i].isLocated) {
          locoArray[i].isLocated = false;
          terminalStatus.terminalStatusLocos[this.allStatusdata.isLocatedKey][i].isLocated = false;
          break;
        }
      }
      this.allStatusdata.isLocated = false;
      terminalStatus.isLocated = false;
      this.allStatusdata.isLocatedKey = '';
      terminalStatus.isLocatedKey = '';
      const tabDataNew = <TabData>({
        id: this.tab.id,
        subType: this.tab.subType
      });
      tabDataNew.data = {};
      tabDataNew.data[this.tab.subType] = terminalStatus;
      this.dataStoreService.putValue(this.tab, tabDataNew);
    }
  }

  /**
   * when spinner change event occur
   * then set sponner value
   * @param {number} newvalue
   * @memberOf LmsTerminalHeaderComponent
   */
  onChange(event: any, type: string) {
    this.prepareOtherOptionsMenu();
    this.saveSpinNoThroughTrainData = { newvalue: event, typename: type };
    if (this.tab) {
      if (this.tab.tabSearchParameter) {
        if (this.editModeService.isEditMode) {
          const actionname = this.pendingActionsLength > 1 ? 'actions' : 'action';

          this.showWarnPop = true;
          this.warnMessage = `${this.terminalConfigMessage.youHave} ${this.pendingActionsLength} ${actionname} ${this.terminalConfigMessage.pendingWithoutSubmit}`;
          return;
        } else {
          this[this.saveSpinNoThroughTrainData['typename']] = event;
          this.terminalStatusService.clean(this.tab);
          const tab: Tab = this.utilService.deepClone(this.tab);
          tab.tabSearchParameter.spinnerVal = this.spinnerVal;
          tab.tabSearchParameter.noThroughTrains = this.noThroughTrains;
          tab.subTypeDetail[tab.subType.toLowerCase()].status = 'refresh';
          this.addToPendingService.resetAll();
          this.lmsModuleService.updateSelectedTab(tab);
        }
      }
    }
  }


  hideWarnPopup() {

    // when we check box its ui state change so to revert its state we do this things
    if (this.saveSpinNoThroughTrainData && this.saveSpinNoThroughTrainData['typename'] === 'noThroughTrains') {
      this.noThroughTrains = !this.saveSpinNoThroughTrainData['newvalue'];
    } else {
      this.spinnerVal = this.lastSpinValue;
    }

    this.showWarnPop = false;
    this.warnMessage = '';
    this.updateEnterButtonFocus('');
  }

  goToRefresh() {
    const editModeStatus = {
      status: false,
      message: ''
    };

    this.editModeService.setEditMode(editModeStatus);
    this.hideWarnPopup();
    if (this.saveSpinNoThroughTrainData['typename'] !== 'noThroughTrains') {
      this.lastSpinValue = this.saveSpinNoThroughTrainData['newvalue'];
    }
    this.onChange(this.saveSpinNoThroughTrainData['newvalue'], this.saveSpinNoThroughTrainData['typename']);
  }

  /**
   * Open plan locomotive popup.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  openPlanLocoPopup() {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    if (this.trainClickCounter === 1 && this.locoClickCounter) {
      this.lmsTabsDragDropService.updateDropEndValue('end', {
        dragElement: {
          type: 'INBOUND',
          train: null,
          loco: 'last'
        },
        dropElement: {
          type: 'OUTBOUND',
          train: {
            index: 0,
            identifier: this.locoPlanTrain.trainIdentifier,
            data: this.locoPlanTrain
          },
          loco:
            {
              index: 0,
              identifier: null
            }
        },
        trainLocos: this.trainLocosData
      }
      );
      this.resetLocoPlanTrain();
    } else {
      this.lmsTabsDragDropService.updateDropEndValue('end', {
        dragElement: {
          type: 'PLAN',
          train: {
            index: 0,
            identifier: null
          },
          loco: {
            index: 0,
            identifier: null
          }
        },
        dropElement: {
          type: 'LOCO',
          train: {
            index: 0,
            identifier: null
          },
          loco:
            {
              index: 0,
              identifier: null
            }
        },
        trainLocos: this.trainLocosData
      }
      );
    }
  }

  /**
   * open train popoup.
   * @param {any} type
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  openTrainPopup(type) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    this.lmsTabsDragDropService.updateDropEndValue('end', {
      dragElement: {
        type: type,
        train: null,
        loco: 'last'
      },
      dropElement: {
        type: 'train',
        train: null,
        loco: 'last'
      },
      trainLocos: this.trainLocosData
    }
    );
  }

  /**
   * Invoked after view initialize.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  ngAfterViewInit() {
    this.enablePendingList = false;
  }

  /**
   * Invoked when changes in lifecycle hook.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  ngOnChanges() {
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.noThroughTrains = this.tab && this.tab.tabSearchParameter && this.tab.tabSearchParameter.noThroughTrains ? true : false;

    if (commonopsPicklist && commonopsPicklist.setOfTerminals) {
      const terminalCommonInfoArr = commonopsPicklist.setOfTerminals;
      if (terminalCommonInfoArr && this.tab.tabSearchParameter && this.tab.tabSearchParameter.searchText) {
        this.summary = _.find(terminalCommonInfoArr,
          { 'terminalMnemonic': this.tab.tabSearchParameter.searchText.trim().toUpperCase() });
        this.lastSpinValue = this.spinnerVal;
        if (this.summary) {
          if (this.summary.city) {
            this.summary.city = this.summary.city.trim();
          }
          if (this.summary.oprRegionName) {
            this.summary.oprRegionName = this.summary.oprRegionName.trim();
          }
          if (this.summary.oprZoneName) {
            this.summary.oprZoneName = this.summary.oprZoneName.trim();
          }
          if (commonopsPicklist.masterData && commonopsPicklist.masterData.divisonList) {
            const divisionArr = commonopsPicklist.masterData.divisonList;
            if (divisionArr && this.summary) {
              const divisionObj: TerminalCommonInfo = _.find(divisionArr, { 'divisionCode': this.summary.divisionCode });
              if (divisionObj) {
                this.summary.divisionName = divisionObj.divisionName;
              }
            }
          }
        }
      }
    }
    this.locosSelected = false;
    this.trainSelected = false;
    this.prepareOtherOptionsMenu();
  }


  /**
  * To check for numeric value.
  * @private
  * @param {string} value
  * @returns {boolean}
  * @memberOf LmsTerminalHandlingComponent
  */
  public isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }

  /**
   * Destroy the lifecycle hook.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  ngOnDestroy() {
    this.lmsTabsDragDropSubscribe.unsubscribe();
    this.addToPendingSubscribe.unsubscribe();
    this.enablePendingListSubscribe.unsubscribe();
    this.locosSelected = false;
    this.trainSelected = false;
  }

  /**
   * Rule exception popup submit.
   * @param {string} type
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  ruleExceptionSubmit(type: string) {
    this.ruleExceptionInfoPopup = false;
    this[type] = true;
    for (let i = 0; i < this.lmsExceptionList.length; i++) {
      if (this.lmsExceptionList[i].isSelectedLoco) {
        const a = {
          currentTerminalIdentifier: this.tab.tabSearchParameter.searchText,
          terminalIdentifier: '',
          terminalHandlingType: '',
          locoTransferList: {
            locomotiveIdentifier: '',
            qualifier: '',
            assignedOrPlanned: '',
            tripPlanCompIndicator: this.lmsExceptionList[i].tripPlamCompExcptnInd,
            tripPlanTrainIdentifier: this.lmsExceptionList[i].tripPlanTrnId,
            tripPlanOverrideCode: this.lmsExceptionList[i].tripPlanOverrideCode,
            tripPlanOverrideReason: this.lmsExceptionList[i].tripPlanOverrideReason,
            unscheduledQShop: this.lmsExceptionList[i].unscheduledQShop,
            unscheduledQShopDate: this.lmsExceptionList[i].unscheduledQShopDate
          }
        };
        this.locoTransfer.push(a);
      }
    }
  }

  /**
   * Service call for bre loco transfer.
   * @param {AddToPendingList} pendingAction
   * @param {string} trainId
   * @param {Array<String>} locoId
   * @param {string} type
   * @param {any} pendingActionIndex
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  serviceCallToBre(pendingAction: AddToPendingList, trainId: string, locoId: Array<String>, type: string, pendingActionIndex) {
    this.terminalStatusService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        const breTrasferParam: BreTransferAreaDetails = <BreTransferAreaDetails>data;
        if (breTrasferParam && breTrasferParam.priorityCode) {
          const pCode = parseInt(breTrasferParam.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.isLmsExceptionListExist(breTrasferParam)) {
              this.ruleExceptionInfoPopup = true;
              for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
                const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
                lmsException.locoId =
                  this.appUtilityService.formatLocomotiveId(lmsException.locoId);
                this.lmsExceptionList[i] = lmsException;

                for (let j = 0; j < pendingAction.locos.length; j++) {
                  if (this.appUtilityService.formatLocomotiveId(pendingAction.locos[j].locomotiveIdentifier)
                    === lmsException.locoId) {
                    pendingAction.locos[j].isLmsExceptionExist = true;
                    pendingAction.locos[j].isSubmitBreLoco = true;
                    pendingAction.locos[j].checked = false;
                    if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
                      pendingAction.locos[j].isLmsExceptionInAddReason = true;
                    } else {
                      pendingAction.locos[j].isLmsExceptionInAddReason = false;
                    }

                    if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
                      pendingAction.locos[j].isLmsExceptionInAddQShop = true;
                    } else {
                      pendingAction.locos[j].isLmsExceptionInAddQShop = false;
                    }

                  }
                }
              }
              this.lmsExceptionOutput.emit({ 'lmsExceptionList': this.lmsExceptionList });

              this.lmsLoaderService.hideLoader();
              this.errorPendingCounter++;
              this.pendingActionCounter++;
              this.loadFreshData();
            } else {
              const breSubmitLocoTransfer: Array<LocoTransfer> = [];
              const selectedLocmotives = _.filter(pendingAction.locos, { checked: true });
              for (let i = 0; i < selectedLocmotives.length; i++) {
                const selectedLocmotive = selectedLocmotives[i];
                const lTransfer = {
                  currentTerminalIdentifier: this.tab.tabSearchParameter.searchText, // To be To be verified
                  terminalHandlingType: pendingAction.planLoco,
                  trainIdentifier: trainId,
                  locoTransferList: {
                    locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                    qualifier: selectedLocmotive.qualifier,
                    assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                    tripPlanCompIndicator: selectedLocmotive.tripPlamCompExcptnInd,
                    tripPlanTrainIdentifier: selectedLocmotive.tripPlanTrnId,
                    tripPlanOverrideCode: selectedLocmotive.tripPlanOverrideCode,
                    tripPlanOverrideReason: selectedLocmotive.tripPlanOverrideReason,
                    unscheduledQShop: selectedLocmotive.unscheduledQShop,
                    unscheduledQShopDate: selectedLocmotive.unscheduledQShopDate,
                    intendedUsageCode: selectedLocmotive.intendedUsageCode,
                    intendedUsageReason: selectedLocmotive.intendedUsageReason,
                    intendedUsageNotes: selectedLocmotive.intendedUsageNote
                  }
                };
                breSubmitLocoTransfer.push(lTransfer);
              }
              this.serviceCallLocoTransfer(breSubmitLocoTransfer, 'XTRN', pendingActionIndex);
            }
          } else {
            this.lmsLoaderService.hideLoader();
            for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
              this.pendingActions[pendingActionIndex].locos[k].checked = false;
            }
            this.pendingActions[pendingActionIndex].hasError = true;
            this.pendingActions[pendingActionIndex].errorMessage = breTrasferParam.messageText;
            this.errorPendingCounter++;
            this.pendingActionCounter++;
            this.loadFreshData();
          }
        }

      }, error => {
        this.lmsLoaderService.hideLoader();
        for (let k = 0; k < this.pendingActions[pendingActionIndex].locos.length; k++) {
          this.pendingActions[pendingActionIndex].locos[k].checked = false;
        }
        this.pendingActions[pendingActionIndex].hasError = true;
        this.pendingActions[pendingActionIndex].errorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        this.errorPendingCounter++;
        this.pendingActionCounter++;
        this.loadFreshData();
      }
    );
  }

  /**
   * Submit rule exception info popup.
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  submitRuleExceptionInfoPopup() {
    this.ruleExceptionInfoPopup = false;
  }

  /**
   * Check for exception exist in bre loco transfer list.
   * @param {BreTransferAreaDetails} breTrasferParam
   * @returns {boolean}
   * @memberOf LmsTerminalStatusHeaderComponent
   */
  isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * this methos is use to reset train status due to
   * when we click on loco after train then we no need to set
   * train click status so to reset do this thing
   * @private
   * @memberof LmsTerminalStatusHeaderComponent
   */
  private resetLocoPlanTrain() {
    const inBoundTrains = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (inBoundTrains[i].trainIdentifier === this.locoPlanTrain.trainIdentifier) {
        inBoundTrains[i].clicked = false;
        inBoundTrains[i].order = 0;
        break;
      }
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (outBoundTrains[i].trainIdentifier === this.locoPlanTrain.trainIdentifier) {
        outBoundTrains[i].clicked = false;
        outBoundTrains[i].order = 0;
        break;
      }
    }
    this.locoPlanTrain = null;
    this.trainClickCounter = 0;
    this.locoClickCounter = 0;
  }

  clearAllSelection() {
    const inBoundTrains = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const terminalList = this.allStatusdata.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      inBoundTrains[i].clicked = false;
      inBoundTrains[i].order = 0;
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      outBoundTrains[i].clicked = false;
      outBoundTrains[i].order = 0;
    }

    if (!this.trainSelected) {
      for (let i = 0; i < inBoundTrainsLength; i++) {
        for (let j = 0; j < inBoundTrains[i].locoDetails.length; j++) {
          inBoundTrains[i].locoDetails[j].clicked = false;
          inBoundTrains[i].locoDetails[j].order = 0;
        }
      }

      for (let i = 0; i < outBoundTrainsLength; i++) {
        for (let j = 0; j < outBoundTrains[i].locoDetails.length; j++) {
          outBoundTrains[i].locoDetails[j].clicked = false;
          outBoundTrains[i].locoDetails[j].order = 0;
        }
      }
      const locosLength = totalTerminalListLocos.length;
      for (let k = 0; k < locosLength; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          for (let l = 0; l < totalTerminalListLocos[k].length; l++) {
            totalTerminalListLocos[k][l].clicked = false;
            totalTerminalListLocos[k][l].order = 0;
          }
        }
      }
    }
    this.lmsTabsDragDropService.updateInteractiveLocoTrains();
  }

  cancelAllLocomotives() {
    const inBoundTrains = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const terminalList = this.allStatusdata.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;

    const locoDataArr: Array<LocoDetail> = [];

    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (inBoundTrains[i] && inBoundTrains[i].locoDetails && inBoundTrains[i].locoDetails.length > 0) {
        for (let j = 0; j < inBoundTrains[i].locoDetails.length; j++) {
          if (inBoundTrains[i].locoDetails[j] && inBoundTrains[i].locoDetails[j].clicked) {
            locoDataArr.push(inBoundTrains[i].locoDetails[j]);
          }
        }

      }
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (outBoundTrains[i] && outBoundTrains[i].locoDetails && outBoundTrains[i].locoDetails.length > 0) {
        for (let j = 0; j < outBoundTrains[i].locoDetails.length; j++) {
          if (outBoundTrains[i].locoDetails[j] && outBoundTrains[i].locoDetails[j].clicked) {
            locoDataArr.push(outBoundTrains[i].locoDetails[j]);
          }
        }

      }
    }

    const locosLength = totalTerminalListLocos.length;
    for (let k = 0; k < locosLength; k++) {
      if (!_.isEmpty(totalTerminalListLocos[k])) {
        for (let l = 0; l < totalTerminalListLocos[k].length; l++) {
          if (totalTerminalListLocos[k][l] && totalTerminalListLocos[k][l].clicked) {
            locoDataArr.push(totalTerminalListLocos[k][l]);
          }
        }
      }
    }

    if (locoDataArr && locoDataArr.length > 0) {
      const selectedLocoArr = [];
      for (let i = 0; i < locoDataArr.length; i++) {
        if (locoDataArr[i] && this.appUtilityService.isPlannedLoco(locoDataArr[i])) {
          selectedLocoArr.push(locoDataArr[i]);
        }
      }
      if (selectedLocoArr && selectedLocoArr.length > 0) {
        const locos = [];
        for (let i = 0; i < selectedLocoArr.length; i++) {
          const select = {
            rowID: '',
            locomotiveID: this.appUtilityService.formatLocomotiveId(selectedLocoArr[i].locomotiveIdentifier),
            assignedPlannedFlag: selectedLocoArr[i].assignedPlannedFlag,
            qualifier: selectedLocoArr[i].qualifier
          };
          locos.push(select);
        }

        const request = {
          otherLocosList: locos
        };
        const operation = {
          operation: 'CancelLocomotivePlan',
          data: request,
          currentTerminal: this.tab.tabSearchParameter.searchText,
          windowCode: 'LWTW',
          mainLocodata: selectedLocoArr,
          trainData: [],
          addToPendingList: this.pendingActions,
          screenName: 'terminal-status'
        };
        this.popUpService.setPopupOperation(operation);
      }
    }
  }

  /**
   * Update focus of enter button.
   * @param {string} btnId
   * @memberof LmsTerminalStatusHeaderComponent
   */
  updateEnterButtonFocus(btnId: string) {
    if (btnId && btnId.length > 0) {
      this.popUpService.setPageMode('Edit');
      this.popUpService.setSubmitBtnId(btnId);
    } else {
      this.popUpService.setSubmitBtnId('');
    }
  }

  private prepareOtherOptionsMenu() {
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.commonopsPicklist &&
      this.commonopsPicklist.masterData &&
      this.commonopsPicklist.masterData.userAuthDetails &&
      this.commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = this.commonopsPicklist.masterData.userAuthDetails.allocationRole;
    }
    this.otherOptions = [
      {
        label: 'Complete Train', command: () => {
          this.otherActionTaken('completeTrain');
        }, disabled: !this.trainSelected
      },
      {
        label: 'Cancel Train', command: () => {
          this.otherActionTaken('cancelTrain');
        }, disabled: !this.trainSelected
      },
      {
        label: 'Allocate', command: () => {
          this.otherActionTaken('allocate');
        }, disabled: !this.locosSelected || (this.user && !this.user.isUserManagerOrDirector) || !this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW'))
      },
      {
        label: 'Deallocate', command: () => {
          this.otherActionTaken('deallocate');
        }, disabled: !this.locosSelected || (this.user && !this.user.isUserManagerOrDirector) || !this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW'))
      },
      {
        label: 'Cancel Locomotive Plan', command: () => {
          this.otherActionTaken('cancelLocomotivePlan');
        }, disabled: !this.locosSelected || !this.totalCancellableLocos || (this.totalCancellableLocos && this.totalCancellableLocos === 0)
          || (this.user && !this.user.isUserManagerOrDirector)
      }
    ];
  }

  public otherActionTaken(action: string) {
    if (('completeTrain').toUpperCase() === action.toUpperCase()) {
      this.openTrainPopup('complete');
    } else if (('cancelTrain').toUpperCase() === action.toUpperCase()) {
      this.openTrainPopup('cancel');
    } else if (('allocate').toUpperCase() === action.toUpperCase()) {
      const operation = {
        operation: 'AllocateLocomotives',
        data: this.buildRequestParamForAllocateAndDeallocate(),
        windowCode: 'LWTW'
      };
      this.popUpService.setPopupOperation(operation);
    } else if (('deallocate').toUpperCase() === action.toUpperCase()) {
      const operation = {
        operation: 'DeallocateLocomotives',
        data: this.buildRequestParamForAllocateAndDeallocate(),
        windowCode: 'LWTW'
      };
      this.popUpService.setPopupOperation(operation);
    } else if (('cancelLocomotivePlan').toUpperCase() === action.toUpperCase()) {
      this.cancelAllLocomotives();
    }
  }

  checkForContextMenuVisiblity(event) {
    // this.hideContextMenu.emit(true);
  }

  buildRequestParamForAllocateAndDeallocate(): Array<LocoDetail> {
    const inBoundTrains = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const terminalList = this.allStatusdata.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];
    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;

    const locoDataArr: Array<LocoDetail> = [];

    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (inBoundTrains[i] && inBoundTrains[i].locoDetails && inBoundTrains[i].locoDetails.length > 0) {
        for (let j = 0; j < inBoundTrains[i].locoDetails.length; j++) {
          if (inBoundTrains[i].locoDetails[j] && inBoundTrains[i].locoDetails[j].clicked) {
            locoDataArr.push(inBoundTrains[i].locoDetails[j]);
          }
        }

      }
    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (outBoundTrains[i] && outBoundTrains[i].locoDetails && outBoundTrains[i].locoDetails.length > 0) {
        for (let j = 0; j < outBoundTrains[i].locoDetails.length; j++) {
          if (outBoundTrains[i].locoDetails[j] && outBoundTrains[i].locoDetails[j].clicked) {
            locoDataArr.push(outBoundTrains[i].locoDetails[j]);
          }
        }

      }
    }
    const locosLength = totalTerminalListLocos.length;
    for (let k = 0; k < locosLength; k++) {
      if (!_.isEmpty(totalTerminalListLocos[k])) {
        for (let l = 0; l < totalTerminalListLocos[k].length; l++) {
          if (totalTerminalListLocos[k][l] && totalTerminalListLocos[k][l].clicked) {
            locoDataArr.push(totalTerminalListLocos[k][l]);
          }
        }
      }
    }
    return locoDataArr;
  }
}
